export enum HttpResponseStatusCode {
  Unauthorized = 401,
  BadRequest = 400,
  OK = 200
}
